import { defineComponent as _defineComponent } from 'vue'
import MobileMenuHeader from './MobileMenuHeader.vue';
import MobileMenuItem from './MobileMenuItem.vue';
import { christmasGuide, setMenuOpenClasses, toylandShop, unsetOpenClasses } from '../../util/menu.utils';
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { IHeaderJson } from 'JS/types/Header';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenu',
  props: {
    headerData: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	headerData: IHeaderJson,
}





const currentMenu = ref(null);
const menuHistory = ref([]);


const headerText = computed(() => {
	if (currentMenu.value) return currentMenu.value.name;
	return props.headerData.localStoreJson ? 'Your Store' : null;
});

const animalRxMenu = computed(() => {
	return props.headerData.deptMenu.find(d => d.id === "13");
});

const deptMenu = computed(() => {
	return props.headerData.deptMenu.filter(d => d.id !== "13");
});

const christmasLink = computed(() => {
	const now = new Date();
	if (christmasGuide(now)) {
		return { id: 24, name: 'Christmas Gift Guide', url: '/gifts/', icon: 'gift', class: 'primary mobile-menu-item__red' };
	}
	return null;
});

const toylandLink = computed(() => {
	const now = new Date();
	if (toylandShop(now)) {
		if (!christmasGuide(now)) {
			return { id: 23, name: 'Shop Toyland', url: '/toyland/', icon: 'gift', class: 'primary mobile-menu-item__red' };
		} else {
			return { id: 23, name: 'Toyland', url: '/toyland/', icon: 'wishlist', class: 'primary' };
		}
	}
	return null;
});

const mainLinks = computed(() => {
	const pts = props.headerData.customer ? props.headerData.customer.rewardsTotalPoints : 0;
	const mainLinks = [
		{ id: 12, name: 'Departments', action: 'deptMenu', icon: 'cart', class: 'primary' },
		{ id: 21, name: 'My Account', url: '/account/', class: 'primary', icon: 'user' },
		{ id: 15, name: 'Current Ad', url: '/sales-flyer/', class: 'primary', icon: 'current-ad' },
		{ id: 20, name: 'Automotive Service Center', icon: 'automotive-service', class: 'primary', children: [
			{ parentID: 20, name: 'Tires', url: '/tires/' },
			{ parentID: 20, name: 'Batteries', url: '/batteries/' },
			{ parentID: 20, name: 'Services & Repair', url: '/automotive-service-repair/' },
		]
		},
		{ id: 19, name: 'Today\'s Deals', url: '/todays-deals/', class: 'primary', icon: 'best-price' },
		{ id: 14, name: 'Blain\'s Rewards', url: '/account/rewards/', action: 'rewards', secondaryText: props.headerData.loggedIn ? `${pts} pts` : null, class: 'primary', icon: 'blain-eagle' },
		{ id: 18, name: 'Store Finder', url: '/store-finder/', class: 'primary',  icon: 'eagle-pin' },
		{ id: 13, name: 'Blain\'s Animal Rx', class: 'primary', action: 'animalRx', icon: 'animal-rx' },
		{ id: 6, name: 'Gift Cards', url: '/gift-cards/', class: 'primary', icon: 'giftcard' },
		{ id: 17, name: 'Registries & Lists', url: '/gift-registry/', class: 'primary', icon: 'reglists' },
		{ id: 16, name: 'Blain\'s Blog', url: '/blog/', class: 'primary', icon: 'blainblog' },
		{ id: 9, name: 'Customer Care', children: [
			{ parentID: 9, name: 'Contact Farm & Fleet', url: '/customer-care/' },
			{ parentID: 9, name: 'SDS Request Form', url: '/sds-request/' },
			{ parentID: 9, name: 'Shipping & Returns', url: '/shipping-returns/' },
			{ parentID: 9, name: 'Product Recalls', url: '/recalls/' },
			{ parentID: 9, name: 'Rebates', url: '/rebates/' },
			{ parentID: 9, name: 'SMS Text Messaging Help', url: '/sms/' },
			{ parentID: 9, name: 'FAQ', url: '/faq/' },
		] },
		{ id: 8, name: 'Services', children: [
			{ parentID: 8, name: 'Drive-Thru Pickup', url: '/store-pickup/' },
			//{ parentID: 8, name: 'Drive-Thru Service', url: '/drivethru/' },
			{ parentID: 8, name: 'Credit Card', url: '/mastercard/' },
			{ parentID: 8, name: 'Extended Service Program', url: '/best-program/' },
			{ parentID: 8, name: 'Fishing & Hunting Licenses', url: '/fishing-hunting-licenses/' },
			{ parentID: 8, name: 'Gift Registries', url: '/gift-registry/' },
			{ parentID: 8, name: 'Other Services', url: '/other-services/' },
		] },
		{ id: 22, name: 'Blain\'s Mastercard', url: '/mastercard/' },
		{ id: 7, name: 'Gift Guide', url: '/gifts/' },
		{ id: 10, name: 'Our Company', children: [
			{ parentID: 10, name: 'About Us', url: '/about-us/' },
			{ parentID: 10, name: 'News', url: '/blog/category/events-news/' },
			{ parentID: 10, name: 'Careers', url: 'https://careers.farmandfleet.com/' },
			{ parentID: 10, name: 'Modeling', url: '/modeling/' },
			{ parentID: 10, name: 'Real Estate', url: 'https://realestate.farmandfleet.com' },
			{ parentID: 10, name: 'History', url: '/history/' },
			{ parentID: 10, name: 'Community', url: '/community/' },
			{ parentID: 10, name: 'Our Theme Song', url: '/theme-song/' },
			{ parentID: 10, name: 'Legal Notice', url: '/legal-notice/' },
			{ parentID: 10, name: 'Privacy Policy', url: '/privacy-policy/' },
			{ parentID: 10, name: 'Coupons', url: '/coupons/' },
			{ parentID: 10, name: 'Coupon Policy', url: '/coupon-acceptance-policy/' }
		] }
	];
	if (toylandLink.value) {
		mainLinks.splice(1, 0, toylandLink.value);
	}
	if (christmasLink.value) {
		mainLinks.splice(1, 0, christmasLink.value);
		return mainLinks.filter(x => x.id !== 7);
	}
	return mainLinks;
});


function goBack() {
	const oldMenu = currentMenu.value;
	let focusID = "";

	currentMenu.value = menuHistory.value[menuHistory.value.length - 1];
	menuHistory.value.pop();

	//Department menu main page
	if (currentMenu.value == null && Array.isArray(oldMenu)) {
		focusID = '12';
	} else {
		focusID = oldMenu.id;
	}

	nextTick(()=> {
		const el = document.querySelector(`.mobile-menu-item--${focusID}`) as HTMLElement;
		if (el) {
			el.focus();
		}
	});
}

function expand(menuItem) {
	if (handleAction(menuItem.action)) {
		return;
	}

	if ((!menuItem.children || menuItem.children.length < 1) && menuItem.url) {
		window.location.replace(menuItem.url);
	} else {
		menuHistory.value.push(currentMenu.value);
		currentMenu.value = menuItem;
		focusBackButton();
	}
}

function handleAction(action) {
	if (action === 'deptMenu') {
		menuHistory.value.push(currentMenu.value);
		currentMenu.value = deptMenu.value;
		focusBackButton();
		return true;
	}

	if (action === 'rewards') {
		props.headerData.loggedIn ? window.location.replace('/account/rewards/')
			: window.location.replace('/rewards/');
		return true;
	}

	if (action === 'animalRx') {
		menuHistory.value.push(currentMenu.value);
		currentMenu.value = animalRxMenu.value;
		focusBackButton();
		return true;
	}

	return false;
}

function handleMegaMenuEscape() {
	emit('close');
}

function focusBackButton() {
	nextTick(()=> {
		const el = document.querySelector(".drawer-head__back-btn") as HTMLElement;
		if (el) {
			el.focus();
		}
	});
}

onMounted(()=> {
	setMenuOpenClasses(true);
});

onUnmounted(() => {
	unsetOpenClasses();
});


return { __sfc: true,props, emit, currentMenu, menuHistory, headerText, animalRxMenu, deptMenu, christmasLink, toylandLink, mainLinks, goBack, expand, handleAction, handleMegaMenuEscape, focusBackButton, MobileMenuHeader, MobileMenuItem }
}

})